import router from "../router/index";
import { signInUsingToken, signOut } from "../constants/apollo-gtweb-client";
import { apolloClient } from "../constants/apollo-provider";
import {
  GT_USER_ID,
  GT_AUTH_TOKEN,
  GT_USER_CONFIG,
  GT_USER_AGENT_ID,
  GT_ITI_AGENT_CURRENCY,
  GT_LOCAL_SETTINGS,
  GT_USER_AGENT_NAME,
  GT_USER_LOGIN_TIME,
} from "../constants/settings";
import layoutSettings from "../constants/layout-settings";
import { UPDATE_VUE_SETTINGS } from "../constants/graphql";
export const storeUser = ({ commit }, authData) => {
  localStorage.setItem(GT_AUTH_TOKEN, authData.token);
  localStorage.setItem(GT_USER_ID, authData.id);
  localStorage.setItem(GT_USER_LOGIN_TIME, new Date().getTime());
  //add access settings to user config
  const {
    config,
    accessSettings,
    email,
    logo,
    agent,
    department,
    brand,
    destinationId,
    domain,
    vueSettings,
    owner,
    username,
    name,
  } = authData;
  config.email = email;
  config.logo = logo;
  config.accessSettings = accessSettings;
  config.agentLanguageId = agent.languageId;
  config.department = department;
  config.brand = brand;
  config.destinationId = destinationId;
  config.domain = domain;
  config.ownerId = owner.id;
  config.username = username;
  config.name = name;
  config.ownerName = owner.name;
  config.agentCompanyCode = agent.companyCode;
  authData.config = config;
  authData.itineraryAgentCurrency = agent
    ? agent.financeSettings.currencyCode
    : null;
  authData.agentName = agent ? agent.name : "";
  localStorage.setItem(GT_USER_CONFIG, JSON.stringify(config));
  localStorage.setItem(GT_USER_AGENT_ID, authData.agentId);
  localStorage.setItem(GT_USER_AGENT_NAME, authData.agentName);
  localStorage.setItem(GT_ITI_AGENT_CURRENCY, authData.itineraryAgentCurrency);
  localStorage;
  if (vueSettings && vueSettings.toString() != "") {
    localStorage.setItem(GT_LOCAL_SETTINGS, vueSettings);
    commit("updateLocalSettings", JSON.parse(vueSettings));
  }
  commit("authUser", authData);
};
export const checkAuth = async ({ commit, state }, toRoute) => {
  //console.log('checking stored apiKey');
  const apiKey = localStorage.getItem(GT_AUTH_TOKEN);

  if (!apiKey) {
    if (toRoute.query.token) {
      signInUsingToken(toRoute);
      //router.replace(toRoute.path);
      return;
    } else {
      router.replace("/");
      return;
    }
  }
  //check for token expiry
  const loginTime = localStorage.getItem(GT_USER_LOGIN_TIME);
  if (loginTime) {
    const timeDiff = new Date().getTime() - parseInt(loginTime);
    const expirationTime = 10 * 60 * 60 * 1000; //10
    if (timeDiff > expirationTime) {
      localStorage.removeItem(GT_USER_ID);
      localStorage.removeItem(GT_AUTH_TOKEN);
      commit("clearAuthData");
      router.replace("/");
      alert("Your session has expired");
      return;
    }
  }
  const userId = localStorage.getItem(GT_USER_ID);
  if (userId) {
    const authData = { token: apiKey, id: userId };
    //check for other stored info
    const agentId = localStorage.getItem(GT_USER_AGENT_ID);
    const agentName = localStorage.getItem(GT_USER_AGENT_NAME);
    const itineraryAgentCurrency = localStorage.getItem(GT_ITI_AGENT_CURRENCY);
    const config = JSON.parse(localStorage.getItem(GT_USER_CONFIG));

    commit("authUser", {
      ...authData,
      agentId,
      agentName,
      config,
      itineraryAgentCurrency,
    });
    router.push({ path: toRoute.path });
  }
};
export const logout = ({ commit }) => {
  signOut().then(() => {
    localStorage.removeItem(GT_USER_ID);
    localStorage.removeItem(GT_AUTH_TOKEN);
    commit("clearAuthData");
    router.replace("/");
  });
};
export const showAppSnackbar = ({ commit }, snackOptions) => {
  const color = snackOptions.color ? snackOptions.color : "success";
  commit("updateAppSnackbar", { show: true, ...snackOptions, color });
};

export const updateLocalSettings = ({ commit, state }, payload) => {
  const settings = { ...state.localSettings, ...payload };
  //update localstorage first
  localStorage.setItem(GT_LOCAL_SETTINGS, JSON.stringify(settings));
  commit("updateLocalSettings", payload);
  apolloClient
    .mutate({
      mutation: UPDATE_VUE_SETTINGS,
      variables: { input: JSON.stringify(settings) },
    })
    .then(() => {
      //just log it
      //console.log("layout settings updated");
    });
};
export const initLocalSettings = ({ commit }) => {
  const stored = localStorage.getItem(GT_LOCAL_SETTINGS);
  if (stored) {
    commit("updateLocalSettings", JSON.parse(stored));
  } else {
    commit("updateLocalSettings", { ...layoutSettings });
  }
};
export const setItineraryAgent = ({ commit }, agentId) => {
  commit("updateItineraryAgent", agentId);
};
export const setItineraryAgentName = ({ commit }, agentName) => {
  commit("updateItineraryAgentName", agentName);
};
export const setItineraryAgentDepartment = ({ commit }, department) => {
  commit("updateItineraryAgentDepartment", department);
};
export const setItineraryAgentCurrency = ({ commit }, currencyCode) => {
  commit("updateItineraryAgentCurrency", currencyCode);
};
export const setItineraryDepartment = ({ commit }, department) => {
  commit("updateItineraryDepartment", department);
};
export const setAppToolbarInfo = ({ commit }, info) => {
  commit("updateAppToolbarInfo", info);
};
export const setInactivityTime = ({ commit }, time) => {
  commit("updateInactivityTime", time);
};



// WEBPACK FOOTER //
// ./src/store/actions.js